module.exports = __webpack_public_path__ + "static/media/5-1.518c7204.webp";